// Module
var code = "<template> <require from=\"app/cm/components/case/member-diagnoses\"></require> <member-diagnoses case-id.bind=\"caseId\" readonly.bind=\"false\"></member-diagnoses> </template> ";
// Exports
module.exports = code;